module.exports = __webpack_public_path__ + "static/media/icon_offer.cdbe3dd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RoadMap/icon_offer.svg
// module id = 1097
// module chunks = 0